<template>
  <div id="userLoginPan">
    <el-button @click="loginCheck" round class="bnsize"
      >進 &nbsp;&nbsp;&nbsp;入</el-button
    >
  </div>
</template>
<script>
export default {
  emits: ['changeLoginWayEvent'],
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    changeLoginType () {
      this.$emit('changeLoginWayEvent')
      this.onClose()
    },
    loginCheck () {
      this.$router.push('/imgList/barrel').catch(() => {})
    },
    onOpen () {},
    onClose () {
      this.dialogVisible = false
      this.$refs.elForm.resetFields()
    },
    userLogin () {
      this.$refs.elForm.validate(valid => {
        if (!valid) return
        this.doLogin()
      })
    },
    doLogin () {
      const api = '/md/front/user/login'
      const params = {
        account: this.formData.userNickName,
        passwd: this.formData.userPasswd
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$store.commit('setGlobalObjOfNowUserLoginState', true)
          // this.$router.push('/imgTypes').catch(() => {}) // 让vue router帮我们进入目标组件
          this.$router.push('/imgList/barrel').catch(() => {})
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bnsize {
  font-size: 20px;
  position: relative;
}

#userLoginPan :deep(.el-input__inner) {
  color: #000;
}
</style>
